<template>
  <v-menu
    :close-on-content-click='false'
    offset-x
    left
    nudge-left='30px'
    transition='slide-x-reverse-transition'
    :value='showSearch'
  >
    <template v-slot:activator='{ on }'>
      <v-icon v-on='on' @click='openSearch' large>mdi-magnify</v-icon>
    </template>
    <v-card width='600' class='px-4 pt-2'>
      <v-text-field
        v-model='search'
        prepend-icon='mdi-magnify'
        label='Search Invoices'
        :loading='searching'
        :hint='searchStatus'
        persistent-hint
        ref='invoiceSearch'
        append-icon='mdi-close'
        @click:append='clearSearch'
      >
      </v-text-field>
      <v-list>
        <v-list-item v-for='r in results' :key='r.id' @click='openItem(r)'>
          <v-list-item-content class='content'>
            <v-list-item-title>
              {{ r.number }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ r.bill_to_display }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if='r.project_data !== null && r.project_data !== undefined' class="text-center">
              {{ r.project_data.name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else>
            </v-list-item-subtitle>
            <v-list-item-subtitle class='text-right'>
              {{ r.amount_os | decMoney }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if='!searching && search.trim().length > 2 && results.length === 0'>
          <v-list-item-content>
            <v-list-item-subtitle class='grey--text'>
              No invoices found for "{{ search.trim() }}"
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import accountingAPI from '@/api/accounting';
import _ from 'lodash';

export default {
  name: 'invoice-lookup-menu',
  data: () => ({
    searching: false,
    showSearch: false,
    search: '',
    searchStatus: '',
    results: []
  }),
  watch: {
    'search' () {
      const length = this.search.trim().length
      if (length > 2) {
        this.executeSearch()
      } else if (length > 0) {
        const remaining = 3 - length
        this.searchStatus = `Type ${remaining} more letter${remaining > 1 ? 's' : ''} to search`
        this.executeSearch(true)
      } else {
        this.searchStatus = ''
        this.results = []
      }
    }
  },
  computed: {

  },
  methods: {
    executeSearch: _.debounce(function (exact) {
      this.searching = true
      if (!exact) {
        this.searchStatus = `Searching for "${this.search.trim()}"...`
      }
      this.searchAPI(exact)
    }, 300),

    async searchAPI (exact) {
      if (this.search === '') {
        this.results = []
      } else {
          this.results = await accountingAPI.invoiceLookup(this.search.trim(), null, exact)
      }
      if (!exact) {
        this.searchStatus = ''
      }
      this.searching = false
    },
    openItem (item) {
      this.$router.push({ name: 'InvoiceOverview', params: { id: item.id }})
      this.showSearch = false
      this.clearSearch()
    },
    clearSearch () {
      this.search = ''
      this.results = []
    },
    openSearch () {
      this.showSearch = true
      setTimeout(() => {
        this.$refs.invoiceSearch.focus()
      }, 100)
    }
  },
  components: {

  }
}
</script>

<style scoped>

.content {
    display: grid;
    grid-template-columns: 150px repeat(4, 1fr);
    grid-gap: 5px;
}

</style>